import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { AutoRedirectRule } from '../../../models/auto-redirect-rule';

import { AutoRedirectRuleService } from '../../../services/auto_rules/auto-redirect-rule.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-auto-redirect-rule-form',
  templateUrl: './auto-redirect-rule-form.component.html',
  styleUrls: ['./auto-redirect-rule-form.component.scss'],
})
export class AutoRedirectRuleFormComponent implements OnInit {
  autoRedirectRuleId: number;

  autoRedirectRule: AutoRedirectRule = new AutoRedirectRule();

  formOptions: any = {};

  loading: boolean = true;

  saving: boolean = false;

  constructor(private notyService: NotyService, private location: Location, private route: ActivatedRoute, private router: Router, private autoRedirectRuleService: AutoRedirectRuleService) {}

  // Component lifecycle methods
  ngOnInit() {
    this.loading = true;
    this.autoRedirectRuleService.formOptions().then((response_json) => {
      this.loading = false;
      this.formOptions = response_json;
      this.autoRedirectRuleId = this.route.snapshot.params['id'];
      if (this.autoRedirectRuleId)
        this.autoRedirectRuleService.edit(this.autoRedirectRuleId).then((response_json) => {
          this.autoRedirectRule = response_json.auto_redirect_rule;
        });
    });
  }

  // Component methods
  back() {
    this.location.back();
  }

  save() {
    this.saving = true;
    this.autoRedirectRuleService
      .save(this.autoRedirectRule)
      .then((response_json) => {
        this.saving = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Auto redirect rule saved', 'success');
          this.router.navigateByUrl('/auto_redirect_rules');
        } else this.notyService.notify(response_json.text || 'Error saving auto redirect rule', 'error');
      })
      .catch(() => {
        this.saving = false;
        this.notyService.notify('Error saving auto redirect rule', 'error');
      });
  }
}
